export default "__VITE_ASSET__DiqJHEy0__"